import { ResourceModel } from '@bryntum/schedulerpro'

export function stopsSorter(item1: ResourceModel, item2: ResourceModel) {
  const stops1 = item1.getData('stopsCount') as uui.domain.client.rm.SchedulerResource['stopsCount']

  const stops2 = item2.getData('stopsCount') as uui.domain.client.rm.SchedulerResource['stopsCount']

  return stops1.current - stops2.current
}
